import { getInitiativeJiraIssuesSelector } from '../../@arch/selectors';
import { InitiativeStatusSelector } from '../../StatusSelector';
import { coreActions, FeatureFlag, InitiativeStatus } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo } from 'react';
import { useAction, useFeatureFlag, useInterval, useSonarSelector } from '@hooks';

export interface InitiativeSidebarStatusSelectorProps {
	initiativeId: number;
	status: InitiativeStatus | undefined;
}

export const InitiativeSidebarStatusSelector: React.FC<InitiativeSidebarStatusSelectorProps> = ({
	initiativeId,
	status
}) => {
	const jiraEnabled = useFeatureFlag(FeatureFlag.JiraIntegration);
	const jiraIssueData = useSonarSelector(getInitiativeJiraIssuesSelector.data);
	const jiraStatusSync = useMemo(
		() => jiraEnabled && jiraIssueData?.some((issue) => issue.isSynced),
		[ jiraEnabled, jiraIssueData ]
	);

	const getInitiative = useAction(coreActions.requestGetCoreInitiativesById);

	const refreshInitiative = useCallback(() => {
		if (jiraStatusSync) {
			getInitiative({
				id: initiativeId
			});
		}
	}, [ getInitiative, initiativeId, jiraStatusSync ]);

	useInterval(refreshInitiative, 10000);

	const updateInitiative = useAction(coreActions.requestPatchCoreInitiativesById);

	const handleChangeStatus = useCallback(
		(statusId: InitiativeStatus) => {
			updateInitiative({
				initiativeId: initiativeId,
				patchInitiativeDescription: {
					initiativeStatusId: statusId
				}
			});
		},
		[ initiativeId, updateInitiative ]
	);

	return (
		<InitiativeStatusSelector
			disabled={ jiraStatusSync }
			id='initiative-status-select'
			onChange={ handleChangeStatus }
			value={ status } />
	);
};
